import React from 'react';
import DocumentMeta from 'react-document-meta';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import DOMPurify from 'dompurify';
import {AdSlot, DFPManager} from 'react-dfp';
import styled from 'styled-components';
import ReactEcharts from './ReactECharts';
import Loading from './Loading';
import {getRaceDetails, selectEvent, getRunnerResults, toggleFavorite, switchRace} from '../actions/race';
import AddFavoriteIcon from '../icons/add-favorite';
import RemoveFavoriteIcon from '../icons/remove-favorite';
import StarIcon from '../icons/star';

class Runner extends React.Component {

  constructor(props, context) {
    super(props, context);

    window.certLoaded = this.certLoaded.bind(this);
  }

  state = {
    selectedTab: 'results',
    loading: true,
    notFound: false,
    showCertLoading: true
  };

  certLoaded() {
    this.setState({showCertLoading: false});
  }

  componentWillMount() {

    if (this.props.match.params.raceId) {
      this.props.getRaceDetails(this.props.match.params.raceId);
      this.props.selectEvent(this.props.match.params.eventId);
      this.props.getRunnerResults(this.props.match.params.raceId, this.props.match.params.eventId, this.props.match.params.bib);
    }

  }
  componentWillReceiveProps(nextProps){

    if(nextProps.runnerResult && nextProps.runnerResult.$KEY === nextProps.match.params.bib) {
      this.setState({loading: false});
    }

    if(nextProps.runnerResult && nextProps.runnerResult.$KEY === undefined) {
      this.setState({notFound: true, loading: false});
    }

    if (this.props.match.params.raceId !== nextProps.match.params.raceId) {
      this.props.switchRace(nextProps.match.params.raceId);
      this.setState({selectedTab: 'results'});
    }
    if (this.props.match.params.raceId !== nextProps.match.params.raceId || this.props.match.params.eventId !== nextProps.match.params.eventId) {
      this.props.selectEvent(nextProps.match.params.eventId);
    }

    if (this.props.match.params.raceId !== nextProps.match.params.raceId || this.props.match.params.eventId !== nextProps.match.params.eventId || this.props.match.params.bib !== nextProps.match.params.bib) {
      const _this = this;
      this.setState({loading: true}, () => {
        _this.props.getRunnerResults(nextProps.match.params.raceId, nextProps.match.params.eventId, nextProps.match.params.bib);
      });

    }
  }

  componentDidUpdate() {
    if (this.props.raceDetail && this.props.raceDetail.name && this.props.runnerResult) {
      const name = this.props.runnerResult.$TEAM_NAME || `${this.props.runnerResult.$FIRST_NAME} ${this.props.runnerResult.$LAST_NAME}`;
      document.title = `RaceResults 360 - ${this.props.raceDetail.name} - ${name}`;
    }
  }

  componentDidMount() {
    // console.log('DFPing!');
    DFPManager.load(["below-runner-results"]);
  }


  toggleFavorite(runner, fav) {
    this.props.toggleFavorite(runner, fav);
  }

  selectTab(tab) {
    this.setState({selectedTab: tab});
  }


  getPieData(num, denom) {

    return {
      title: {
        show: true,
        text: parseInt((num/denom)*100) + '%',
        right: 0,
        textStyle: {color: this.props.color}
      },
      tooltip: {show: false},
      legend: {show: false},
      series: [{
        type: 'pie',
        center: ['25%', '50%'],
        radius : '65%',
        silent: true,
        data: [
          {value: num, itemStyle : {normal : {color: this.props.color, label : {show : true}, labelLine : {show : false}}}},
          {value: denom-num, itemStyle : {normal : {color: '#C7C8C9', label : {show : false}, labelLine : {show : false}}}}
        ]
      }]
    };
  }



  render() {

    const chartStyle = {height: '54px', width: '80px', display: 'inline-block',     verticalAlign: 'middle'};

    const {raceDetail} = this.props;

    const runnerResult = Object.assign({}, this.props.runnerResult);
    Object.keys(runnerResult).map((key, idx) => {
      if (key !== 'MAPPINGS') {
        runnerResult[key] = DOMPurify.sanitize(runnerResult[key]);
      }
    });

    const meta = {
      title: document.title,
      description: `Online Race Results for ${runnerResult.$FIRST_NAME || ''} ${runnerResult.$LAST_NAME || ''} in the ${raceDetail.name} ${raceDetail.event_type} event. Powered by RaceResults 360.`,
      canonical: location.href,
      meta: {
        charset: 'utf-8',
        name: {
          keywords: `raceresults360,${raceDetail.name},${raceDetail.event_type},${raceDetail.city},${raceDetail.state},${raceDetail.country},athletes,runners,triathletes`
        }
      }
    };



    const isFavorite = runnerResult && this.props.favorites && this.props.favorites.filter(x => x.$KEY === runnerResult.$KEY).length > 0;

    // console.log(runnerResult);
    // console.log(raceDetail);

    if (this.state.loading || !runnerResult) {
      return (
        <Loading />
      );
    }

    if (this.state.notFound) {
      if (this.props.isMobile) {
        return(
          <div>
            <DocumentMeta {...meta} />
            <div className="header">
              <h5 className="title" style={{backgroundColor: this.props.color}}>{raceDetail.name}</h5>

              <div className="info-block clearfix">
                <h3>Athlete</h3>

                <a href={`#/race/${raceDetail.race_id}`} className="btn menubutton">Menu</a>
              </div>
            </div>
            <div className="block-wrap">
              <div className="block clearfix">
                <div className="block-text">
                  Participant Not Found.
                </div>
              </div>
            </div>
          </div>
        )
      }
      return (
        <div className="section-result">
          <Link to={`/race/${this.props.match.params.raceId}/${this.props.match.params.eventId}`} style={{marginLeft: '10px'}}> &lt; Back to Results</Link>
          <div className="section-head">
            Participant Not Found.
          </div>
        </div>
          );
    }

    if (this.props.isMobile) {
      return (
        <div>
          <DocumentMeta {...meta} />
          <div className="header">
            <h5 className="title" style={{backgroundColor: this.props.color}}>{raceDetail.name}</h5>

            <div className="info-block clearfix">
              <h3>Athlete</h3>

              <a href={`#/race/${raceDetail.race_id}`} className="btn menubutton">Menu</a>
            </div>
          </div>
          <div className="block-wrap">
            <div className="block clearfix">
              <div className="block-text">
                <h4>
                  {runnerResult.$TEAM_NAME ? (
                    runnerResult.$TEAM_NAME
                  ) : (
                    `${runnerResult.$FIRST_NAME} ${runnerResult.$LAST_NAME}`
                  )}
                  <span>Bib: {runnerResult.$KEY}</span>
                </h4>
              </div>
              <div className="block-btns">
                <a id="toggle-favorite" onClick={this.toggleFavorite.bind(this, runnerResult, !isFavorite)}>
                  {isFavorite ?
                    <RemoveFavoriteIcon width={'72px'} height={'72px'} />
                   :
                    <AddFavoriteIcon />
                  }
                </a>
              </div>
            </div>

            {runnerResult.$TEAM_NAME &&
            <div className="section">
              {(runnerResult.$TM1_FIRST || runnerResult.$TM1_LAST) && <p><strong>{`${runnerResult.$TM1_FIRST} ${runnerResult.$TM1_LAST}`}</strong></p>}
              {(runnerResult.$TM2_FIRST || runnerResult.$TM2_LAST) && <p><strong>{`${runnerResult.$TM2_FIRST} ${runnerResult.$TM2_LAST}`}</strong></p>}
              {(runnerResult.$TM3_FIRST || runnerResult.$TM3_LAST) && <p><strong>{`${runnerResult.$TM3_FIRST} ${runnerResult.$TM3_LAST}`}</strong></p>}
              {(runnerResult.$TM4_FIRST || runnerResult.$TM4_LAST) && <p><strong>{`${runnerResult.$TM4_FIRST} ${runnerResult.$TM4_LAST}`}</strong></p>}
              {(runnerResult.$TM5_FIRST || runnerResult.$TM5_LAST) && <p><strong>{`${runnerResult.$TM5_FIRST} ${runnerResult.$TM5_LAST}`}</strong></p>}


            </div>
              }

            <div className="section">
              <p><strong>City, State:</strong> {runnerResult.$CITY && (<span>{runnerResult.$CITY} </span>)} {runnerResult.$STATE && (<span>{runnerResult.$STATE}</span>)}</p>
              <p><strong>Division:</strong> {runnerResult.$DIV || ''}</p>
              <br />
              <p><strong>Division Place:</strong> {runnerResult.$DIV_PLACE || ''}{runnerResult.$DIV_TOTAL ? `/${runnerResult.$DIV_TOTAL}` : ''}</p>
              <p><strong>Gender Place:</strong> {runnerResult.$GENDER_PLACE || ''}{runnerResult.$GENDER_TOTAL ? `/${runnerResult.$GENDER_TOTAL}` : ''}</p>
              <p><strong>Overall Place:</strong> {runnerResult.$OVERALL || ''}{runnerResult.$OVERALL_TOTAL ? `/${runnerResult.$OVERALL_TOTAL}` : ''}</p>
            </div>
          </div>

          <div className="table-info">
            <table width="100%" border="0" cellSpacing="0" cellPadding="0">
              <thead>
                <tr>
                  <th>Location</th>
                  <th>Time</th>
                  <th>Pace</th>
                </tr>
              </thead>
              <tbody>

              {runnerResult && runnerResult.MAPPINGS && runnerResult.MAPPINGS.map((location, idx) => (
                <tr className={`${idx % 2 === 0 ? 'results-odd' : 'results-event'}`} key={idx}>
                  <td dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(location.location)}} />
                  <td dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(`${runnerResult[location.current_segment] || ''} ${location.distance ? `(${location.distance}${location.distance_unit})` : '' }`)}} />
                  <td dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runnerResult[location.pace] ? `${runnerResult[location.pace]}/mile` : '')}} />
                </tr>

              ))}</tbody>
            </table>
          </div>
        </div>
      );
    }

    const eventId = this.props.match.params.eventId || '';

    let eventName = '';
    try {
      eventName = this.props.raceDetail.event_mapping.find(x => x.key === eventId).name;
    } catch(e) {
      // do nothing
    }

    const ThemeColorStrong = styled.strong`
      color: ${this.props.color} !important;
    `;

    return (
      <div className="section-result">
        <DocumentMeta {...meta} />
        <Link to={`/race/${this.props.match.params.raceId}/${eventId}`} style={{color: '#6c6b6b', marginLeft: '10px', width: '62px'}}> &lt; Back</Link>
          {this.props.ads && this.props.ads.showFull && this.props.ads.type === 'adsense' &&
            <div style={{width: "728px", height: "90px", position: "absolute", right: 0, top: 0, textAlign: "center !important"}}>
            <AdSlot sizes={[[728,90]]}
                    dfpNetworkId='15308329'
                    adUnit='AboveRunner'
                    slotId="above-runner-results"
              // targetingArguments={ {'customKw': 'test'} }
              // sizeMapping={ [ {viewport: [1024, 768], sizes:[[728, 90], [300, 250]]},
              //   {viewport: [900, 768], sizes:[[300, 250]] }] }
              //       onSlotRender={this.loadSecondaryAd}
              /* never refresh this adSlot */
                    shouldRefresh={() => true}
            />
            </div>
          }
        <div className="section-head" style={{marginTop: '49px'}}>
          <div className="section-head-inner clearfix">
            <div className="result-position">
              <ThemeColorStrong>Bib</ThemeColorStrong>

              <h1>{runnerResult.$KEY}</h1>
            </div>

            <div className="result-information">
              <h2>
                {runnerResult.$TEAM_NAME ? (
                  runnerResult.$TEAM_NAME
                ) : (
                  `${runnerResult.$FIRST_NAME} ${runnerResult.$LAST_NAME}`
                )}
              </h2>

              <div className="result-actions">
                <a className="link-add-fav toggle-favorite2">

                  {isFavorite ? (
                    <span>
                      <StarIcon checked style={{display: 'inline-block', height: '22px', width: '22px', marginTop: '10px'}} onClick={this.toggleFavorite.bind(this, runnerResult, !isFavorite)} />
                      <span id="favorite-span">Remove Favorite</span>
                    </span>
                  ) : (
                    <span>
                      <StarIcon checked={false} style={{display: 'inline-block', height: '22px', width: '22px', marginTop: '10px'}} onClick={this.toggleFavorite.bind(this, runnerResult, !isFavorite)} />
                      <span id="favorite-span">Add Favorite</span>
                    </span>
                  )}
                </a>
              </div>
            </div>

            <div className="result-address">
              <p>
                {runnerResult.$CITY && (<span>{runnerResult.$CITY} </span>)} {runnerResult.$STATE && (<span>{runnerResult.$STATE}</span>)}
                {(runnerResult.$CITY || runnerResult.$STATE) && (<br />)}
                {runnerResult.$USAT_AGE && (<span>Age: {runnerResult.$USAT_AGE} <br /></span>)}
                {runnerResult.$SEX && (<span>Gender: {runnerResult.$SEX} <br /></span>)}
              </p>
            </div>

            <div className="result-position finaltime">
              <ThemeColorStrong>Final Time</ThemeColorStrong>
              <h1>{runnerResult.$FINALTM || ''}</h1>
            </div>
          </div>

          <div className="result-achievments">
            <div className="cols clearfix">
              <div className="col col-size1">
                <div className="result-achievment">
                  <div className="result-achievment-head">
                    <h4>Division</h4>
                  </div>

                  <div className="result-achievment-body">
                    <h2>{runnerResult.$DIV || ''}</h2>
                  </div>
                </div>
              </div>

              <div className="col col-size2">
                <div className="result-achievment">
                  <div className="result-achievment-head">
                    <h4>Division Place</h4>
                  </div>

                  <div className="result-achievment-body">
                    <ThemeColorStrong className="result-place">{runnerResult.$DIV_PLACE || ''}</ThemeColorStrong>
                  </div>

                  <div className="result-achievment-foot">

                    <strong>{runnerResult.$DIV_TOTAL || ''}</strong>

                  </div>
                </div>
              </div>


              <div className="col col-size2">
                <div className="result-achievment">
                  <div className="result-achievment-head">
                    <h4>Gender Place</h4>
                  </div>

                  <div className="result-achievment-body">
                    <ThemeColorStrong className="result-place">{runnerResult.$GENDER_PLACE || ''}</ThemeColorStrong>
                  </div>

                  <div className="result-achievment-foot">

                    <strong>{runnerResult.$GENDER_TOTAL || ''}</strong>

                  </div>
                </div>
              </div>


              <div className="col col-size2">
                <div className="result-achievment">
                  <div className="result-achievment-head">
                    <h4>Overall Place</h4>
                  </div>

                  <div className="result-achievment-body">
                    <ThemeColorStrong className="result-place">{runnerResult.$OVERALL || ''}</ThemeColorStrong>
                  </div>

                  <div className="result-achievment-foot">

                    <strong>{runnerResult.$OVERALL_TOTAL || ''}</strong>

                  </div>
                </div>
              </div>

            </div>
            {runnerResult.$TEAM_NAME &&
            <div>
              <br /><br />
              <strong>Team Members:</strong>
              {(runnerResult.$TM1_FIRST || runnerResult.$TM1_LAST) && <p>{`${runnerResult.$TM1_FIRST} ${runnerResult.$TM1_LAST}`}</p>}
              {(runnerResult.$TM2_FIRST || runnerResult.$TM2_LAST) && <p>{`${runnerResult.$TM2_FIRST} ${runnerResult.$TM2_LAST}`}</p>}
              {(runnerResult.$TM3_FIRST || runnerResult.$TM3_LAST) && <p>{`${runnerResult.$TM3_FIRST} ${runnerResult.$TM3_LAST}`}</p>}
              {(runnerResult.$TM4_FIRST || runnerResult.$TM4_LAST) && <p>{`${runnerResult.$TM4_FIRST} ${runnerResult.$TM4_LAST}`}</p>}
              {(runnerResult.$TM5_FIRST || runnerResult.$TM5_LAST) && <p>{`${runnerResult.$TM5_FIRST} ${runnerResult.$TM5_LAST}`}</p>}
            </div>
            }
          </div>
        </div>

        <div className="section-body">
          <div className="tabs">
            <div className="tabs-head">
              <div className="tabs-nav">
                <ul>
                  <li className={`detailsTab ${this.state.selectedTab === 'results' ? 'current' : ''}`} onClick={this.selectTab.bind(this, "results")}>
                    <span>Individual Results</span>
                  </li>

                  <li className={`detailsTab ${this.state.selectedTab === 'charts' ? 'current' : ''}`} onClick={this.selectTab.bind(this, "charts")}>
                    <span>Charts</span>
                  </li>

                  {(this.props.match.params.raceId === 'GaXsPS' || this.props.match.params.raceId === 'aORSrg') &&
                    <li className={`detailsTab ${this.state.selectedTab === 'cert' ? 'current' : ''}`} onClick={this.selectTab.bind(this, "cert")}>
                      <span>Certificate</span>
                    </li>
                  }

                  <li className="detailsTab hide">
                    <span>Photos</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="tabs-body">
              {this.state.selectedTab === 'results' &&
              <div className="tab current" id="tab1">
                <div className="table">
                  <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                    <thead>
                      <tr>
                        <th width="170">Location</th>

                        <th width="170">Time</th>

                        <th width="180">Pace</th>

                        <th>cTime</th>

                        <th>Ranking Division</th>

                        <th>Ranking Overall</th>
                      </tr>
                    </thead>
                    <tbody>
                      {runnerResult && runnerResult.MAPPINGS && runnerResult.MAPPINGS.map((location, idx) => (
                        <tr className={`${idx % 2 === 0 ? 'results-odd' : 'results-event'}`} key={idx}>
                          <td dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(location.location)}} />
                          <td dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(`${runnerResult[location.current_segment] || ''} ${location.distance ? `(${location.distance}${location.distance_unit})` : '' }`)}} />
                          <td dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(`${runnerResult[location.pace] || ''}${location.pace_unit ? `/${location.pace_unit}` : ''}`)}} />
                          <td dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runnerResult[location.cumulative] || '')}} />
                          <td dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(`${runnerResult[location.rank_div] || ''}${runnerResult.$DIV_TOTAL && runnerResult[location.rank_div] ? `/${runnerResult.$DIV_TOTAL}` : ''}`)}}></td>
                          <td dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(`${runnerResult[location.rank_overall] || ''}${runnerResult.$OVERALL_TOTAL && runnerResult[location.rank_overall] ? `/${runnerResult.$OVERALL_TOTAL}` : ''}`)}}></td>
                        </tr>

                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              }
              {this.state.selectedTab === 'charts' &&
              <div className="tab current" id="tab2">
                <ul className="charts">
                  {runnerResult.$DIV_TOTAL && (
                    <li className="chart">
                      <strong>Division Place</strong>
                      <ReactEcharts style={chartStyle} option={this.getPieData(parseInt(runnerResult.$DIV_PLACE), parseInt(runnerResult.$DIV_TOTAL))} showLoading={false} />
                    </li>
                  )}
                  {runnerResult.$GENDER_TOTAL && (
                    <li className="chart">
                      <strong>Gender Place</strong>
                      <ReactEcharts style={chartStyle} option={this.getPieData(parseInt(runnerResult.$GENDER_PLACE), parseInt(runnerResult.$GENDER_TOTAL))} showLoading={false} />
                    </li>
                  )}
                  {runnerResult.$OVERAL_TOTAL && (
                    <li className="chart">
                      <strong>Overall Place</strong>
                      <ReactEcharts style={chartStyle} option={this.getPieData(parseInt(runnerResult.$OVERALL), parseInt(runnerResult.$OVERALL_TOTAL))} showLoading={false} />
                    </li>
                  )}
                </ul>

                <div className="table table-tertiary">
                  <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                    <thead>
                    <tr>
                      <th>Location</th>

                      <th>Time</th>

                      <th>

                        <span className="alignleft">Charts</span>

                        <span className="alignright">Division Ranking</span>
                      </th>

                      <th>
                        <span className="alignleft">Charts</span>

                        <span className="alignright">Overall Ranking</span>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    {runnerResult.MAPPINGS.map((location, idx) => (
                      <tr className={`${idx % 2 === 0 ? 'results-odd' : 'results-event'}`} key={idx}>
                        <td dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(location.location)}} />
                        <td dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runnerResult[location.current_segment])}} />

                        <td>
                          {runnerResult.$DIV_TOTAL && location.rank_div && runnerResult[location.rank_div] &&
                          <ReactEcharts style={chartStyle} option={this.getPieData(parseInt(runnerResult[location.rank_div]), parseInt(runnerResult.$DIV_TOTAL))} showLoading={false} />
                          }
                          <span dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(`${runnerResult[location.rank_div] || ''}${runnerResult.$DIV_TOTAL && runnerResult[location.rank_div] ? `/${runnerResult.$DIV_TOTAL}` : ''}`)}} />
                        </td>

                        <td>
                          {runnerResult.$OVERALL_TOTAL && location.rank_overall && runnerResult[location.rank_overall] &&
                          <ReactEcharts style={chartStyle} option={this.getPieData(parseInt(runnerResult[location.rank_overall]), parseInt(runnerResult.$OVERALL_TOTAL))} showLoading={false} />
                          }
                          <span dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(`${runnerResult[location.rank_overall] || ''}${runnerResult.$OVERALL_TOTAL && runnerResult[location.rank_overall] ? `/${runnerResult.$OVERALL_TOTAL}` : ''}`)}} />
                        </td>
                      </tr>

                    ))}
                    </tbody>

                  </table>
                </div>
              </div>
              }
              {this.state.selectedTab === 'cert' &&
                  <div className="tab current" id="tab3">
                    <iframe src={`https://app.raceresults360.com/public/cert.html?key=${this.props.match.params.raceId}%2f${this.props.match.params.eventId}%2f${this.props.match.params.bib}&ename=${eventName}`} frameBorder="0" width="864px" height="654px" />
                  </div>
              }

              <div className="tab" id="tab3"><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Obcaecati ipsum aperiam ratione incidunt, omnis placeat culpa, illum ex, necessitatibus nemo, odit nostrum cum! Unde quas consequuntur commodi, culpa rerum quos.
              </p></div>
            </div>
          </div>
        </div>
        {this.props.ads && this.props.ads.showFull && this.props.ads.type === 'adsense' &&
          <div style={{marginTop: "20px !important", textAlign: "center !important"}}>
          <AdSlot sizes={[[250,250], [300,250], [300,600],[468,60], [728,90]]}
                  dfpNetworkId='15308329'
                  adUnit='BelowRunner'
                  slotId="below-runner-results"
            // targetingArguments={ {'customKw': 'test'} }
            // sizeMapping={ [ {viewport: [1024, 768], sizes:[[728, 90], [300, 250]]},
            //   {viewport: [900, 768], sizes:[[300, 250]] }] }
            //       onSlotRender={this.loadSecondaryAd}
            /* never refresh this adSlot */
                  shouldRefresh={() => true}
          />
          </div>
        }
      </div>
  );
  }
}

function mapStateToProps(state) {
  return {
    raceDetail: state.rr360.raceDetail,
    favorites: state.rr360.favorites,
    results: state.rr360.results,
    eventId: state.rr360.eventId,
    runnerResult: state.rr360.runnerResult,
    isMobile: state.rr360.isMobile,
    ads: state.rr360.ads,
    color: state.rr360.theme.primaryColor
  };
}


export default connect(mapStateToProps, {getRaceDetails, selectEvent, getRunnerResults, toggleFavorite, switchRace})(Runner);



// WEBPACK FOOTER //
// ./src/components/Runner.js